import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Apollo} from "apollo-angular";
import {search_active_employees} from "../../graphql/getCompanyEvents";
import {FormControl} from "@angular/forms";
import {
  create_company_event_attendee,
  delete_company_event_attendee,
  update_company_event_attendee
} from "../../graphql/updateCompanyEvent";
import {ActivatedRoute} from "@angular/router";
import {OutlookEventService} from "../../../services/outlook-event.service";
import {debounceTime, distinctUntilChanged} from "rxjs";

@Component({
    selector: 'company-events-attendees',
    templateUrl: './company-events-attendees.component.html',
    styleUrls: ['./company-events-attendees.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsAttendeesComponent implements OnInit{
  @Input() attendees: any[]
  @Input() userCanEdit:boolean;
  @Output() updateOutlookAttendees = new EventEmitter<any[]>();
  registeredAttendees: any = []
  unregisteredAttendees: any = []
  @Input() outlookAttendees:any = [];
  isEditMode: boolean = false;
  employees: any[] = []
  employeesLoading:boolean = false;
  filterEmployees: any[] =[]
  searchControl: FormControl = new FormControl("")
  searchStore: string;
  selectAttendees: any[] = []
  toggleControl: FormControl = new FormControl(false)

  constructor(private apollo: Apollo, private route: ActivatedRoute, private outlookService: OutlookEventService) {
      this.searchControl.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe((val) => {
        this.searchStore = val;
        this.searchEmployees(val)
      })
  }


  ngOnInit() {
    for(let i = 0; i < this.attendees.length; i++){
      if(this.attendees[i].is_registered){
        this.registeredAttendees.push(this.attendees[i])
      } else {
        this.unregisteredAttendees.push(this.attendees[i])
      }
    }

  }


  editToggle(){
    if(this.isEditMode && this.selectAttendees.length>0){
        this.addAttendees(this.toggleControl.value)
    }
    this.isEditMode = !this.isEditMode
  }

  searchEmployees(val:string){
    if(this.filterEmployees.length>0){
      this.filterEmployees = [];
      this.employees = []
    }
    if(val && val.trim().length>0){
      this.employeesLoading = true;
      let subQuery = this.apollo.watchQuery({
        query: search_active_employees,
        variables: {
          limit: 50,
          search: this.searchStore.trim(),
          searchLike: '%' + this.searchStore.trim() + '%'
        }
      }).valueChanges.subscribe(({data}:any ) => {
        let userResults = data.search_active_users;
        userResults.forEach((person:any) => {
          let employeeObj = {
            name: person.name,
            id: person.id
          }
          this.employees.push(employeeObj)
        })
        subQuery.unsubscribe()
        let uniqueEmpl = this.employees.reduce((arr, el) => {
          if(!arr.some((obj:any) => obj.id === el.id && obj.name === el.name)){
            arr.push(el)
          }
          return arr
        }, [])
        this.filterEmployees = uniqueEmpl;
        this.employeesLoading = false;
      })
    }
  }


  selectEmployee(employee:any){
    this.searchControl.setValue("")
    this.selectAttendees.push({name: employee.option.value.name, id: employee.option.value.id})
  }

  addAttendees(mark_as_registered: boolean){
    for(let i=0; i<this.selectAttendees.length; i++){
        this.apollo.mutate({
          mutation: create_company_event_attendee,
          variables: {
            company_event_id: this.route.snapshot.paramMap.get("id"),
            person_id: this.selectAttendees[i].id,
            is_registered: mark_as_registered
          }
        }).subscribe(({data}:any) => {
          let response = data.createCompanyEventAttendee;
          let dataObj = {
            ...response,
            isOnOutlook: false
          };
          this.attendees.push(dataObj);
          if(response.is_registered){
            this.registeredAttendees.push(dataObj);
          } else {
            this.unregisteredAttendees.push(dataObj);
          }
        })
    }
    this.selectAttendees = []
  }


  editRegistration(response:any,){
    this.apollo.mutate({
      mutation: update_company_event_attendee,
      variables: {
        id: response.id,
        is_registered: response.is_registered
      }
    }).subscribe(({data}: any) => {
        let result = data.updateCompanyEventAttendee
        let dataObj = {
          ...result,
          isOnOutlook: response.isOnOutlook
        }
        this.attendees = this.attendees.map((obj) => obj.id == response.id ? dataObj : obj)
        if(response.is_registered){
          this.unregisteredAttendees = this.unregisteredAttendees.filter((unregistered:any) => unregistered.id!==response.id)
          this.registeredAttendees.push(dataObj)
        } else {
          this.registeredAttendees = this.registeredAttendees.filter((registered:any) => registered.id!==response.id)
          this.unregisteredAttendees.push(dataObj)
        }
    })
  }

  sendOutlookInvite(user:any){
    user.isOnOutlook = !user.isOnOutlook
    let attnIndex = this.attendees.findIndex(usr => usr.id == user.id);
    this.attendees[attnIndex] = user;
    let outlookAttendees = []
    for(let i = 0; i < this.attendees.length; i++){
      if(this.attendees[i].isOnOutlook){
        outlookAttendees.push(this.attendees[i].person.id)
      }
    }
    this.outlookAttendees = outlookAttendees;
    this.updateOutlookAttendees.emit(outlookAttendees)

  }

  deleteAttendee(attendee:any){
    this.apollo.mutate({
      mutation: delete_company_event_attendee,
      variables: {
        id: attendee.id
      }
    }).subscribe(({data}:any) => {
      this.attendees = this.attendees.filter((user) => user.id!==attendee.id)
      this.registeredAttendees = this.registeredAttendees.filter((registered:any) => registered.id!==attendee.id)
      this.unregisteredAttendees = this.unregisteredAttendees.filter((unregistered:any) => unregistered.id!==attendee.id)
      if(attendee.isOnOutlook){
        this.sendOutlookInvite(attendee)
      }
    })
  }

  removeFromSaveList(employee:any){
    this.selectAttendees = this.selectAttendees.filter((value:any) => value.id !== employee.id)
  }

  deleteAll(){
    this.attendees.forEach((attn:any) => {
      this.deleteAttendee(attn)
    })
  }

  registerAll(){
    this.attendees.forEach((attn:any) => {
      if(!attn.is_registered){
        this.editRegistration({id: attn.id, is_registered: true, isOnOutlook: attn.isOnOutlook})
      }
    })
  }

  unregisterAll(){
    this.attendees.forEach((attn:any) => {
      if(attn.is_registered){
        this.editRegistration({id: attn.id, is_registered:false, isOnOutlook: attn.isOnOutlook})
      }
    })
  }

}
